import { Controller } from "remult";

@Controller("user-category-preference-methods")
export class UserCategoryPreferenceMethods {}




